export const LOW_BALANCE_THRESHOLD = 500;

export const MIN_RECHARGE_AMOUNT = 500;

export const GST_RATE = 0.18;

/** Matches payments `PAYMENT_MAX_AMOUNT` default (10_000_000 paise = ₹100,000 incl. GST cap). */
export const PAYMENT_MAX_AMOUNT_PAISE = 10_000_000;

/** Pre-GST credit cap so `amount` sent to initiatePayment stays within gateway limit. */
export const MAX_RECHARGE_AMOUNT = Math.floor(
  PAYMENT_MAX_AMOUNT_PAISE / 100 / (1 + GST_RATE)
);

/** Per message-type volume cap for cost calculator inputs. */
export const MAX_ESTIMATE_MESSAGE_COUNT = 1_000_000;

/** Combined monthly volume cap across all message types in the calculator. */
export const MAX_ESTIMATE_TOTAL_MESSAGES = 2_000_000;

export const ESTIMATE_CREDIT_COST_LABEL = 'Estimate Credit Cost';

export const QUICK_RECHARGE_AMOUNTS = [1000, 2000, 5000];

export const ESTIMATE_COUNTRIES = [
  { code: 'IN', label: 'India' },
];

export const ESTIMATE_MESSAGE_TYPES = [
  { id: 'marketing', apiKey: 'marketing', label: 'Marketing messages' },
  { id: 'utility', apiKey: 'utility', label: 'Utility messages' },
  { id: 'auth', apiKey: 'authentication', label: 'Authentication messages' },
  { id: 'service', apiKey: 'service', label: 'Service messages' },
];

export const DEFAULT_WALLET_STATE = {
  balance: 0,
  baselinePool: 0,
  lastRechargeText: '—',
  transactions: [],
  alertPreferences: {
    notifyInApp: true,
    notifyEmail: true,
    notifyWhatsApp: false,
    alertThreshold: '500',
  },
};
